// extracted by mini-css-extract-plugin
export default {"section":"FormSection_section__n9QqF","head":"FormSection_head__hOejp","num":"FormSection_num__aMM++"};